/** @jsx jsx */
import React, {useState, useEffect} from 'react';
import { css, jsx } from '@emotion/core';
import FlexBox from "components/atoms/FlexBox";
import FlexBoxItem from "components/atoms/FlexBoxItem";
import { productColor } from 'components/styles';
import Icon, {IconType} from 'components/atoms/Icon';
import BodyText from "components/atoms/BodyText";
import { useHistory, useLocation } from 'react-router-dom';
import { GroupMenu } from 'components/templates/menuData';
import BoxMenu from './BoxMenu';
import { MenuItem } from 'components/templates/menuData';
import { checkBoxMenu } from 'components/templates/Sidebar';

const style = {
  boxItem: css({
    padding: "10px 29px", 
    color: "#999999", 
    fontSize: "12px",
    "&:hover": {
      background: "#E7F1FD",
      color: productColor.primary,
      cursor: "pointer"
    }
  }),
  boxSubItem: css({
    cursor: "pointer",
    justifyContent: 'space-between',
    padding: '5px'
  }),
  subMenuLevel1: css({
    padding: "10px", 
    cursor: "pointer"
  }),
  activeItem: css({
    background: "#E7F1FD",
    color: productColor.primary,
    cursor: "pointer"
  }),
  boxMenu: css({
    borderBottom: "1px solid #e6e6e6",
    padding: "10px"
  }),
  boxSubMenu: css({
    overflow: 'hidden',
    maxHeight: '1000px',
    transition: 'max-height 1.4s linear',
  }),
}

const BoxGroupMenu: React.FC<{
  groupMenu: GroupMenu,
  index: number,
  openMenu: boolean,
  setIndexOpen: (index: number|null) => void,
  level: number
}> = ({ groupMenu, index, openMenu, setIndexOpen }) => {
  const history = useHistory();
  const location = useLocation();
  const [indexSubOpen, setIndexSubOpen] = useState<number|null>()

  const handleOpenMenu = () => {
    if(openMenu){
      setIndexOpen(null);
    }else{
      setIndexOpen(index);
    }
  }

  useEffect(() => {
    let group = location.pathname.split('/')[1];
    let currentMenu: number|null = null;
    groupMenu.menuList?.map((item, index) => {
      if(checkBoxMenu(item, group)){
        currentMenu = index;
      }
    });
    setIndexSubOpen(currentMenu);
  }, [])

  let listSubMenu = groupMenu.menuList?.map((subMenu: MenuItem, index: number) => {
    return (
      <BoxMenu
        subMenu={subMenu}
        index={index}
        openMenu={index === indexSubOpen}
        setIndexOpen={(i: number|null) => setIndexSubOpen(i)}
        level={2}
      />
    )
  })
  return(
    <div css={style.boxMenu}>
      <FlexBox customStyle={style.boxSubItem} onClick={handleOpenMenu}>
        <FlexBoxItem>
          <Icon type={groupMenu.icon as IconType} color="black" size="20px" margin="0 8px 0 0"/>
          <BodyText color="black">{groupMenu.display}</BodyText>
        </FlexBoxItem>
        <FlexBoxItem customStyle={css([openMenu ? {transform: 'rotate(90deg)'} : {}, {transition: '0.5s'}])}>
          <Icon 
            type={"chevronMenu"}
            color={productColor.primary} 
            size="12px" 
            verticalAlign="middle"
          />
        </FlexBoxItem>
      </FlexBox>
      <div css={css([style.boxSubMenu, openMenu ? {} : {maxHeight: '0', transition: 'max-height 1.3s cubic-bezier(0, 1, 0, 1)'}])}>
        {listSubMenu}
      </div>
    </div>
  )
};

export default BoxGroupMenu;
